import React from "react"
import styled, { css } from "styled-components"
import { Link } from "gatsby"
import { breakpoints } from "../../../theme"
import { buttonStyle } from "@bw/bits"

const TeaserStyle = css`
  --size: 48px;

  @media (min-width: ${breakpoints.medium}px) {
    --size: 64px;
  }
  text-decoration: none;
  width: 100%;
  display: grid;
  grid-gap: 5px;
  color: var(--font-colors);
  cursor: pointer;
  position: relative;
`

const Image = styled.div`
  > * {
    width: var(--size);
    height: var(--size);
    object-fit: cover;
    object-position: center;
    border-radius: 50%;
  }
`

const StyledLink = styled(Link)`
  ${TeaserStyle}
`
const StyledA = styled.a`
  ${TeaserStyle}
`
const StyledDiv = styled.div`
  ${TeaserStyle}
`
const TeaserBody = styled.div`
  position: relative;
  z-index: 4;
  display: flex;
  flex-direction: column;
  align-items: center;
  text-align: center;
  gap: 10px;
`

const Small = styled.div`
  font-weight: 300;
  font-size: 15px;
  line-height: 176.3%;
  margin-bottom: 0.3em;

  @media (min-width: ${breakpoints.medium}px) {
    font-size: ${props => (props.smaller ? "14px" : "15px")};
  }
`

const Title = styled.div`
  font-family: "Ginto", georgia, serif;
  font-weight: 500;
  font-weight: normal;
  font-size: 10px;
  line-height: 1.2;

  @media (min-width: ${breakpoints.medium}px) {
    font-size: 12px;
  }
`

const Padding = styled.div`
  width: 100%;

  align-self: center;
`

const Button = styled.div`
  ${buttonStyle}
  margin: 25px 0 0 0;
`

const SimpleTeaser = ({
  suptitle,
  title,
  to,
  href,
  onClick,
  image,
  smaller,
  buttonLabel,
}) => {
  const Card = () => (
    <TeaserBody>
      <Image>
        {image ? image : <img src="/placeholder-teaser.jpg" alt="" />}
      </Image>
      <Padding>
        {title && (
          <Title smaller={smaller}>
            {suptitle && <Small smaller={smaller}>{suptitle}</Small>}
            {title}
          </Title>
        )}
        {buttonLabel && (
          <Button $fill $primary>
            {buttonLabel}
          </Button>
        )}
      </Padding>
    </TeaserBody>
  )

  switch (true) {
    case to !== null:
      return (
        <StyledLink to={to}>
          <Card />
        </StyledLink>
      )

    case href !== null:
      return (
        <StyledA href={href} target="_blank">
          <Card />
        </StyledA>
      )

    case onClick !== null:
      return (
        <StyledDiv onClick={onClick}>
          <Card />
        </StyledDiv>
      )

    default:
      throw new Error(
        "Unsupported type of teaser. Should use one of these props: to, href or onClick"
      )
  }
}

export { SimpleTeaser }
